export const GET_ALL_PLAYLIST = 'GET_ALL_PLAYLIST';
export const GET_PLAYLIST = 'GET_PLAYLIST';
export const CREATE_PLAYLIST = 'CREATE_PLAYLIST';
export const DELETE_PLAYLIST = 'DELETE_PLAYLIST';
export const ADD_TO_PLAYLIST = 'ADD_TO_PLAYLIST';
export const DELETE_FROM_PLAYLIST = 'REMOVE_FROM_PLAYLIST';
